<template>
  <div>

    <router-link :to="{path:'/record-completedCourse-detail',query:{id:obj.id}}">
      <div>
        <span class="des" v-text="obj.courseId"></span>
        <span class="des1" v-text="obj.createTime + '>'"></span>
        <div class="line">

        </div>
      </div>
    </router-link>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      obj: {
        type: Object
      }
    },
    methods: {
//       getLocalTime(tm) {
//         var d = new Date(tm * 1000);    // 根据时间戳生成的时间对象
//         var date = (d.getFullYear()) + '-' +
//           (d.getMonth() + 1) + '-' +
//           (d.getDate());
//         return date;
// //        return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
//       }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';
  .des{
    font-size: px2rem(30);
    margin-right: px2rem(50);
    width: px2rem(322);
    color: rgba(94,95,97,1);
  }
  .des1{
    font-size: px2rem(28);
    color: rgba(151,148,139,1);
    overflow: hidden;
    float: right;
    margin-top: px2rem(40);
  }
  .line{
    background-color: rgba(93,46,5,1);
    height: px2rem(2);
  }
</style>



// WEBPACK FOOTER //
// VCoureseShowCell.vue?53802b26